import React, { useEffect, useState } from 'react';
import Table from '../../../components/table';
import {
  useBoolean,
  useGetTablePreferences,
  usePostTablePreferences,
  useWealthlaneCustomerApi,
} from '../../../hooks';
import { ModalStatusType, TableParamsType } from '../../../types/common';
import InitialValuesForm from '../../../constants/initialValues';
import { PageHeader } from '../../../constants/style/common.styled';
import Heading from '../../../components/typography';
import Search from '../../../components/search/search';
import Button from '../../../components/button';
import AnimationWrapper from '../../../components/animation/animationWrapper';
import PushToProductionModal from './pushToProductionModal';
import useInstance from '../../../hooks/custom-hooks/useInstance';
import useGetSandboxProductionList from '../../../hooks/get/useGetSandboxProductionList';
import { SwitchToProductionHeader } from '../../../constants/table-headers/switchToProductionHeader';
import {
  useDynamicTable,
  DynamicTable,
  withDynamicTableContext,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import Spinners from '../../../components/spinner';
import { axiosInstance } from '../../../services/apiInterceptor';

const PushToProduction = () => {
  const { handleRequest } = useWealthlaneCustomerApi();
  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const { tableInfo, setTableInfo } = useDynamicTable();

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);
  const { data: productionList, status } = useGetSandboxProductionList(handleRequest, tableInfo);

  const [searchQuery, setSearchQuery] = useState('');
  const [headerList, setHeaderList] = useState<string[]>([]);

  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false);
  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Add');
  const [rowData, setRowData] = useState<any>();
  const {} = useInstance({ onClose() {} });

  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'PUSH_TO_PRODUCTION_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });
  const { data: tablePreferences } = useGetTablePreferences(handleRequest, 'Push to Production');

  useEffect(() => {
    tablePreferences != null && setHeaderList([...tablePreferences]);
  }, [tablePreferences]);

  const { mutate: postTablePreference, isLoading: tablePrefLoading } =
    usePostTablePreferences(handleRequest);

  const handleSavePreference = (value: string[]): void => {
    const prefPayload = {
      tableName: 'Push to Production',
      preferences: value,
    };
    postTablePreference(prefPayload);
  };

  const tableHeaderList = SwitchToProductionHeader({ actions: schemaData?.columns })
    .filter((item) => item.isSubHeader)
    .map((item) => {
      // console.log('item', item);

      return {
        label: item.Header,
        value: item.accessor,
      };
    });

  const switchToProductionHeader = (): any[] => {
    return SwitchToProductionHeader({ actions: schemaData?.columns }).filter(
      (item) => item.isSubHeader === false || headerList.includes(item.accessor)
    );
  };

  const schema = React.useMemo(
    () => ({
      columns: switchToProductionHeader(),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );

  const renderRightToolbarButton = () => {
    return null;
    // return (
    //   <Button
    //     as='Create'
    //     variant={'primary'}
    //     title={'Load To Main'}
    //     onClick={() => {
    //       setModalStatus('Add');
    //       setRowData([]);
    //       openModal();
    //     }}
    //     icon='add_circle'
    //   />
    // );
  };

  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' id='loadingSpinner' />;

  return (
    <div className='h-full'>
      <PageHeader id='pageHeader'>
        <Heading id='pageTitle' variant='h3' title='Sandbox Load To Main Logs' />
        <Heading id='pageSubtitle' variant='body-s' title='List of Logs.' />
      </PageHeader>
      {/* <div className='grid lg:grid-cols-12 gap-4 lg:gap-1.5 items-start mb-8'>
        <div className='lg:col-span-3'>
          <Search
            placeholder='Search'
            searchValue={searchQuery}
            onSearch={(value: string) => {
              setSearchQuery(value);
            }}
            setTableInfo={setTableInfo}
            tableInfo={tableInfo}
          />
        </div>
        <div className='lg:col-span-9 justify-items-end'>
          <Button
            as='Create'
            variant={'primary'}
            title={'Load To Main'}
            onClick={() => {
              setModalStatus('Add');
              setRowData([]);
              openModal();
            }}
            icon='add_circle'
          />
        </div>
      </div> */}

      <AnimationWrapper id='modalAnimationWrapper'>
        {isModalOpen && (
          <PushToProductionModal
            isModalOpen={isModalOpen}
            closeModal={closeModal}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            rowData={rowData}
            domId='pushToProductionModal'
          />
        )}
      </AnimationWrapper>
      {/* <Table
        columns={SwitchToProductionHeader([])}
        data={productionList?.items ?? []}
        loading={status}
        showPagination={true}
        totalCounts={productionList?.totalCount ?? 10}
        tableInfo={tableInfo}
        setTableInfo={setTableInfo}
      /> */}
      <DynamicTable
        schema={schema}
        data={productionList?.items ?? []}
        totalCounts={productionList?.totalCount ?? 10}
        loading={status}
        components={{
          renderRightToolbarButton,
        }}
        tableColumnList={tableHeaderList}
        selectedColumnList={headerList}
        tablePreferenceLoading={tablePrefLoading}
        handleColumnSave={handleSavePreference}
        id='dataTable'
      />
    </div>
  );
};

export default withDynamicTableContext(PushToProduction, false, axiosInstance);
